import { MarkdownContent } from "~components";
import { DocWorkflowAnswerType, translate as t, type KeyWithEmptyFnParam } from "~utils";

export function ContentAnswer(props: Extract<DocWorkflowAnswerType, { type: "CONTENT" }>) {
  const { text } = props;

  return <MarkdownContent body={t(text as KeyWithEmptyFnParam)} />;
}
